import type { SchemaTypeSummary } from "@/services/wpSeoHealthService";

export interface SchemaTypesChipsProps {
	summary: SchemaTypeSummary[];
	pagesWithoutSchema: number;
}

// Schema chip color cycle — semantic tokens only
const SCHEMA_CHIP_COLORS = [
	"bg-teal-light text-teal-dark",
	"bg-coral-light text-coral-dark",
	"bg-violet-light text-violet-dark",
	"bg-amber-light text-amber-dark",
	"bg-muted text-muted-foreground",
];

export function SchemaTypesChips({ summary, pagesWithoutSchema }: SchemaTypesChipsProps) {
	return (
		<div className="p-4">
			{summary.length > 0 ? (
				<div className="flex flex-wrap gap-2">
					{summary.map((schema, i) => (
						<span key={schema.type} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium ${SCHEMA_CHIP_COLORS[i % SCHEMA_CHIP_COLORS.length]}`}>
							{schema.type}
							<span className="rounded-full bg-card/60 px-1.5 py-0.5 text-xs">{schema.count}</span>
						</span>
					))}
				</div>
			) : (
				<p className="text-sm text-muted-foreground">No schema types detected</p>
			)}
			{pagesWithoutSchema > 0 && (
				<p className="mt-3 text-dash-context text-muted-foreground">{pagesWithoutSchema} pages have no schema markup</p>
			)}
		</div>
	);
}
